export const isSSR = () => __SERVER__ ?? false;
